import { gql } from '@apollo/client';
import { type DocumentNode } from 'graphql';

export const CREATE_CUSTOM_PAGE: DocumentNode = gql`
  mutation createCustomPage($input: CreateCustomPageInput!) {
    createCustomPage(input: $input)
  }
`;
